/**
 * Tenant addresses domain API (Cluster A / A2).
 *
 * 1:N address book per tenant with at most one current address. The flat
 * Tenant.street/postal_code/city/country fields stay the legacy surface and are
 * mirrored server-side from the current address.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  expectPaginatedItems,
  parseAdminErrorResponse,
} from "./core";

export function fetchAdminTenantAddresses(tenantId) {
  const url = `${API_BASE_URL}/api/admin/tenants/${encodeURIComponent(
    tenantId
  )}/addresses`;
  return fetch(url, { headers: getApiHeaders() })
    .then((res) => {
      if (!res.ok) throw new Error("Adressen konnten nicht geladen werden.");
      return res.json();
    })
    .then((data) =>
      expectPaginatedItems(data, "GET /api/admin/tenants/{id}/addresses")
    );
}

export async function createAdminTenantAddress(tenantId, body) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenants/${encodeURIComponent(tenantId)}/addresses`,
    {
      method: "POST",
      headers: getApiHeaders(),
      body: JSON.stringify(body),
    }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}

export async function patchAdminTenantAddress(addressId, body) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenant-addresses/${encodeURIComponent(addressId)}`,
    {
      method: "PATCH",
      headers: getApiHeaders(),
      body: JSON.stringify(body),
    }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}

export async function setCurrentAdminTenantAddress(tenantId, addressId) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenants/${encodeURIComponent(
      tenantId
    )}/addresses/${encodeURIComponent(addressId)}/set-current`,
    { method: "POST", headers: getApiHeaders() }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}

export async function deleteAdminTenantAddress(addressId) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenant-addresses/${encodeURIComponent(addressId)}`,
    { method: "DELETE", headers: getApiHeaders() }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}

/**
 * Option C residential move ("Adresswechsel erfassen"). The server forces
 * address_type='private', is_current=true, valid_to=NULL and closes the previous
 * current residential period — the caller therefore MUST NOT send address_type,
 * is_current or valid_to.
 */
export async function recordAdminTenantAddressChange(tenantId, body) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenants/${encodeURIComponent(
      tenantId
    )}/address-change`,
    {
      method: "POST",
      headers: getApiHeaders(),
      body: JSON.stringify(body),
    }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}
